<style lang="scss" scoped>
.rte {
    ::v-deep p {
        @apply text-18;
    }
}
</style>

<template>
    <section class="flex flex-col justify-end items-start container">
        <h2 v-animate.fade="'slide-up'" class="text-24 lg:text-48 font-medium" v-html="nl2br(data.title)"></h2>
        <div v-animate.fade="'slide-up'" delay="1" class="text-gray mt-24 rte" v-html="data.content"></div>
        <div class="w-100 mt-120">
            <div ref="slider">
                <div v-for="achievement in data.achievements" :key="achievement.id">
                    <achievement :data="achievement" :cta="true"></achievement>
                </div>
            </div>
            <div ref="navContainer" class="mt-24 flex flex-row gap-16">
                <div class="cursor-pointer hover:opacity-75 transition-opacity">
                    <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 8L1 8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8 15L0.999999 8L8 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="cursor-pointer hover:opacity-75 transition-opacity">
                    <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 8L21 8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M14 1L21 8L14 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { tns } from "tiny-slider/src/tiny-slider";

export default {
    props: {
        data: {
            required: true,
            default: () => ({
                id: "",
                title: "",
                content: ""
            })
        }
    },
    data: () => ({
        slider: null,
        sliderInit: false
    }),
    mounted() {
        this.initSlider();
    },
    methods: {
        nl2br(content) {
            if (!content) {
                return "";
            }
            return content.replace(/\n/g, "<br />");
        },
        initSlider() {
            this.slider = tns({
                container: this.$refs.slider,
                nav: false,
                items: 1.2,
                controls: true,
                controlsContainer: this.$refs.navContainer,
                loop: false,
                gutter: 30,
                preventScrollOnTouch: "force",
                mouseDrag: true,
                responsive: {
                    576: {
                        items: 3.1,
                        gutter: 40
                    }
                }
            });
        }
    }
};
</script>
